import { useEffect, useState } from 'react';
import { Path } from 'constants/routes';
import history from 'utils/history';

import { Icon } from '../../Icons';
import Typography from '../../Atoms/Typography';
import ZohoChatSupport from '../../Common/ZohoChartSupport';
import useQuickRunConfiguration from 'hooks/Onboarding/useQuickRunConfiguration';
import TriggerTestSection from './TriggerTestSection/index';
import YamlConfiguarationStep from './YamlConfiguartionStep/index';
import QuickRunFooter from './QuickRunFooter';
import isEnterOrSpacePressed from 'utils/isEnterOrSpacePressed';
import setTitle from 'utils/setTitle';

import './index.css';

function onGoBack() {
  window.history.state
    ? history.goBack()
    : history.push(Path.QUICK_START, {
        previous_page: Path.QUICK_START_YAML_BASED_TEST.Path,
      });
}
const QuickRun = function () {
  const [allStepsCompleted, setAllStepsCompleted] = useState(false);
  const [testStarted, setTestStarted] = useState(false);
  const {
    changeConcurrencyValue,
    changeRetryValue,
    changeTimeoutValue,
    currentConfiguration,
    currentFramework,
    currentOsSelection,
    getCommandToRunTest,
    getYamlCode,
    handleOsChange,
    handleRetriggerJob,
    resetTestStatus,
    showGoToDashBoard,
    triggerButtonHandler,
    updateYaml,
  } = useQuickRunConfiguration();

  useEffect(() => {
    setTitle('quick-run');
  }, []);

  const {
    timeout: timeoutValue,
    retry: retryValue,
    concurrency: concurrencyValue,
  } = currentConfiguration;

  function handleClick() {
    onGoBack();
    resetTestStatus();
  }

  return (
    <div className="ltw-bg-group-list-bg-color ltw-pb-20px quick-run-page-container">
      <div className="ltw-flex ltw-items-center ltw-justify-between ltw-shadow-onboarding-language quick-run-page-header">
        <div className="ltw-flex ltw-items-center">
          <div
            onClick={handleClick}
            onKeyDown={(e) => isEnterOrSpacePressed(e) && handleClick(e)}
            tabIndex="0"
            role="button"
          >
            <Icon
              name={'back-icon'}
              width="13"
              height="13"
              className={'ltw-mr-18px ltw-inline-block ltw-cursor-pointer'}
            />
          </div>

          <Typography
            variant="h2"
            fontSize="ltw-text-14"
            lineHeight="ltw-leading-22"
            fontType="ltw-font-semibold"
            color="ltw-text-black"
          >
            Quick Run {currentConfiguration?.framework?.name} Sample
          </Typography>
        </div>
        <div className="ltw-flex ltw-items-center ltw-gap-11px">
          <div className="ltw-flex ltw-justify-between ltw-gap-15px">
            <ZohoChatSupport />
          </div>
        </div>
      </div>
      <YamlConfiguarationStep
        handleOsChange={handleOsChange}
        concurrencyValue={concurrencyValue}
        changeConcurrencyValue={changeConcurrencyValue}
        retryValue={retryValue}
        changeRetryValue={changeRetryValue}
        timeoutValue={timeoutValue}
        changeTimeoutValue={changeTimeoutValue}
        currentOsSelection={currentOsSelection}
        getYamlCode={getYamlCode}
        currentFramework={currentFramework}
        updateYaml={updateYaml}
        testStarted={testStarted}
      />
      <TriggerTestSection
        getCommandToRunTest={getCommandToRunTest}
        currentFramework={currentFramework}
        triggerButtonHandler={triggerButtonHandler}
        handleAllStepsCompleted={setAllStepsCompleted}
        testStarted={testStarted}
        setTestStarted={setTestStarted}
        handleRetriggerJob={handleRetriggerJob}
        allStepsCompleted={allStepsCompleted}
      />
      <QuickRunFooter
        showGoToDashBoard={showGoToDashBoard}
        allStepsCompleted={allStepsCompleted}
        resetTestStatus={resetTestStatus}
        currentConfiguration={currentConfiguration}
      />
    </div>
  );
};

export default QuickRun;
